import { Record } from "immutable";

const LocaleRecord = Record({
  id: null,
  jaLabel: "",
  nativeLabel: "",
  order: ""
});

class Locale extends LocaleRecord {}

export default Locale;



// WEBPACK FOOTER //
// ./src/models/Locale.js